// src/components/Forms/Select.jsx
import { useController } from 'react-hook-form';

const Select = ({ name, control, label, options, placeholder, rules, disabled = false, ...props }) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control, rules });

  return (
    <div className="form-group">
      {label && <label htmlFor={name}>{label}</label>}
      <select
        id={name}
        disabled={disabled}
        {...field}
        {...props}
        className={error ? 'input-error' : ''}
      >
        <option value="">{placeholder || 'Select an option'}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <span className="error-message">{error.message}</span>}
    </div>
  );
};

export default Select;